module.exports = {
  iconHelpData: "data:image/svg+xml,%3csvg width='24' height='24' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='none' fill-rule='evenodd'%3e%3ccircle stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' cx='12' cy='12' r='11'/%3e%3cpath d='M9.021 8.009c.464-1.175 1.722-1.99 2.99-2.008 1.74-.026 3.996.58 3.99 3.087-.006 2.854-4.073 2.89-4.045 5.367' stroke='currentColor' stroke-width='2' stroke-linecap='round'/%3e%3ccircle fill='currentColor' fill-rule='nonzero' cx='12' cy='18.25' r='1.25'/%3e%3c/g%3e%3c/svg%3e",
  iconHelpWidth: 24,
  iconHelpHeight: 24
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/tokens/base/icon/help.js
// module id = 388
// module chunks = 7